import { render, staticRenderFns } from "./clinic.vue?vue&type=template&id=0017ac8e&scoped=true"
import script from "./clinic.vue?vue&type=script&lang=js"
export * from "./clinic.vue?vue&type=script&lang=js"
import style0 from "./clinic.vue?vue&type=style&index=0&id=0017ac8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0017ac8e",
  null
  
)

export default component.exports